import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import CustomLoader from '../../common/CustomLoader';
import { snakeCaseToTitleCase } from '../../../common/utils/api_utils';
import { Link } from 'react-router-dom';
import {
  collectionTypeBadge,
  descriptionTooltip,
  inUseTooltip,
} from '../../../common/utils/validate';
import voca from 'voca';
import TooltipInfo from '../../../common/docs/TooltipInfo';
export class ListPages extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  };

  extractValue = (value) => {
    let synthesizeValue = value;
    if (Array.isArray(value)) {
      synthesizeValue = value.map((val) => {
        return snakeCaseToTitleCase(val);
      });
      return synthesizeValue.join(', ');
    }
    return snakeCaseToTitleCase(synthesizeValue);
  };
  accessBadgeForDefault = (page) => {
    const { projectDefaultPage } = this.props;
    if (projectDefaultPage) {
      if (projectDefaultPage.name === page) {
        return <span className={'badge mr-1 badge-primary'}>Default</span>;
      }
    }
  };

  accessBadge = (access) => {
    return (
      access &&
      access.map((element, index) => {
        return (
          <span
            key={index}
            className={`badge mr-1 ${
              element.includes('PERMIT_ALL') ? 'badge-success' : 'badge-primary'
            }`}
          >
            {this.extractValue(element)}
          </span>
        );
      })
    );
  };

  extractCollectionTitle = (name) => {
    const { home } = this.props;
    const { collections } = home || '';
    let collectionName = name;
    if (name && collections && collections.length) {
      let collection = collections.find((collection) => collection.collectionName === name);
      collectionName = collection && collection.collectionTitle ? collection.collectionTitle : '';
    }
    return collectionName;
  };

  renderPages = () => {
    const { pages, projectId, version } = this.props;
    if (pages && pages.length > 0) {
      return (
        <div className="row mx-auto h-50 table-responsive show_scrollbar">
          <table className="table table-bordered table-hover table-sm table-word-break">
            <thead>
              <tr>
                <th title="Index">#</th>
                <th title="Name">Name</th>
                <th title="Name">Access</th>
                <th title="Name">Collection</th>
                <th>
                  Description{' '}
                  <TooltipInfo
                    title={descriptionTooltip('page')}
                    headerText={`What's Description?`}
                    showHeader={true}
                    showArrow={true}
                  />
                </th>
                <th>
                  In Use{' '}
                  <TooltipInfo
                    title={inUseTooltip('page')}
                    headerText={`What's In Use?`}
                    showHeader={true}
                    showArrow={true}
                  />
                </th>
                <th title="Action">Action</th>
              </tr>
            </thead>
            <tbody>
              {pages.map(
                ({ uuid, name, access, collectionId, description = '', inUse = true }, index) => {
                  return (
                    <tr key={uuid} className="text-left">
                      <td className="align-middle">{index + 1}</td>
                      <td className="align-middle">
                        {name} {this.accessBadgeForDefault(name)}
                      </td>
                      <td className="align-middle">{this.accessBadge(access)}</td>
                      <td className="align-middle">{this.extractCollectionTitle(collectionId)}</td>
                      <td className="align-middle" title={description} style={{ width: '60%' }}>
                        {voca.truncate(`${description}`, 80)}
                      </td>
                      <td className="align-middle" style={{ width: '10%' }}>
                        {collectionTypeBadge(inUse, 'inuse', 'page')}
                      </td>
                      <td className="align-middle ">
                        <Link
                          to={`/app-setting/${version}/v/${projectId}/setting/page-js/${uuid}`}
                          className="btn btn-xs btn-theme-green"
                          title={`Edit ${name} JS`}
                        >
                          <i className="wb webconnect-braces"></i>
                        </Link>
                      </td>
                    </tr>
                  );
                },
              )}
            </tbody>
          </table>
        </div>
      );
    } else {
      return <div className="alert">No Pages found!</div>;
    }
  };

  render() {
    const { home, activeTab, title } = this.props;
    const { loadPagesPending } = home || '';
    return loadPagesPending ? (
      <div className="text-center">
        <CustomLoader loading={loadPagesPending} size="20px" color="#303453" />
      </div>
    ) : (
      this.renderPages()
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListPages);
